// extracted by mini-css-extract-plugin
module.exports = {"coinSelect":"CoinSelect-module--coinSelect--GQPBW InputElement-module--select--bMC2K InputElement-module--input--2CJgj","option":"CoinSelect-module--option--GF21x"};